/** Set-new-password Alpine component, relocated from inline <script>. Registered via
 * Alpine.data('setNewPassword') in meroserver.js; server args stay on the x-data attr. */
export default function setNewPassword(templateHash, initialExpired) {
    return {
        hash: templateHash || window.location.pathname.split('/').filter(Boolean).pop(),
        password: '',
        passwordConfirm: '',
        showPwd: false,
        loading: false,
        done: false,
        expired: initialExpired || false,

        submit() {
            if (!this.password || this.password !== this.passwordConfirm || this.loading) return;
            this.loading = true;
            API.guest.post(
                'client/update_password',
                {
                    hash: this.hash,
                    password: this.password,
                    password_confirm: this.passwordConfirm
                },
                () => {
                    this.loading = false;
                    this.done = true;
                },
                (res) => {
                    this.loading = false;
                    const msg = (res && res.message) ? res.message : 'Something went wrong. Please try again.';
                    if (/expired|invalid|already|not found/i.test(msg)) {
                        this.expired = true;
                    } else {
                        StablePanel.message(msg, 'error');
                    }
                },
                false
            );
        }
    };
}
